import { render, staticRenderFns } from "./addSparePartInfo.vue?vue&type=template&id=485d76a0&scoped=true"
import script from "./addSparePartInfo.vue?vue&type=script&lang=js"
export * from "./addSparePartInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d76a0",
  null
  
)

export default component.exports